exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal_wrapper_outer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.78);\n  font-family: \"NunitoSans\"; }\n  .modal_wrapper_outer .modal_wrapper_inner {\n    background-color: #fff;\n    width: 60%;\n    border: 1px solid #979797;\n    border-radius: 8px; }\n    .modal_wrapper_outer .modal_wrapper_inner form {\n      text-align: center; }\n      .modal_wrapper_outer .modal_wrapper_inner form fieldset legend {\n        padding: 15px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/add-your-product/modal-item/modal-item.component.scss
// module id = ../../../../../src/app/add-your-product/modal-item/modal-item.component.scss
// module chunks = main